// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2UddL","choiceBoxes":"toolbarselects_choiceBoxes__2IX9x","simpleField":"toolbarselects_simpleField__bGzs-"};